<template>
  <div>
    <RepairService v-if="isRootService" />
    <RepairServiceCategory v-else-if="isCategory" />
    <RepairServiceService v-else-if="isSubcategory && serviceInfo" />
    <RepairServiceSubcategory v-else-if="isSubcategory && !serviceInfo" />
    <RepairServiceSubcategoryService v-else-if="isSubcategoryService" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import RepairService from '@/components/repair/RepairService'
import RepairServiceSubcategory from '@/components/repair/RepairServiceSubcategory'
import RepairServiceService from '@/components/repair/RepairServiceService'
import RepairServiceCategory from '@/components/repair/RepairServiceCategory'
import RepairServiceSubcategoryService from '@/components/repair/RepairServiceSubcategoryService'
import RepairPageMixin from '@/components/repair/RepairPageMixin'

export default {
  name: 'RepairServicePage',
  components: {
    RepairService,
    RepairServiceCategory,
    RepairServiceService,
    RepairServiceSubcategory,
    RepairServiceSubcategoryService,
  },
  mixins: [RepairPageMixin],
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: this.$t('repairPageTitle'),
      }),
      meta: [
        {
          name: 'description',
          content: this.$t('meta.other.descriptionTmpl', {
            h1: this.headline,
          }),
        },
      ],
    }
  },
  computed: {
    ...mapState(['headline']),
  },
  methods: {
    ...mapActions(['setHeadline']),
    updateHeadline() {
      const breadcrumbs = []
      let headline = this.$t('title.repairService')

      if (this.isRootService) {
        breadcrumbs.push({ name: headline })
      } else if (this.isCategory) {
        headline = `${headline} ${this.categoryInfo.name}`
        breadcrumbs.push(
          { name: headline, to: this.getPath() },
          {
            name: this.categoryInfo.name,
          }
        )
      } else if (this.isSubcategory && this.serviceInfo) {
        const head = this.serviceInfo[`description_${this.$i18n.locale}`]
        headline = `${head} ${this.categoryInfo.name}`
        breadcrumbs.push(
          { name: headline, to: this.getPath() },
          {
            name: this.categoryInfo.name,
            to: this.getPath(this.categoryInfo.slug),
          },
          {
            name: head,
          }
        )
      } else if (this.isSubcategory && !this.serviceInfo) {
        headline = `${headline} ${this.subcategoryInfo.name}`
        breadcrumbs.push(
          { name: headline, to: this.getPath() },
          {
            name: this.categoryInfo.name,
            to: this.getPath(this.categoryInfo.slug),
          },
          {
            name: this.subcategoryInfo.name,
          }
        )
      } else if (this.isSubcategoryService) {
        const head = this.serviceInfo[`description_${this.$i18n.locale}`]
        headline = `${this.subcategoryInfo.name} ${head}`
        breadcrumbs.push(
          { name: headline, to: this.getPath() },
          {
            name: this.categoryInfo.name,
            to: this.getPath(this.categoryInfo.slug),
          },
          {
            name: this.subcategoryInfo.name,
            to: this.getPath(
              `${this.categoryInfo.slug}/${this.subcategoryInfo.slug}`
            ),
          },
          {
            name: head,
          }
        )
      }

      this.setHeadline(headline)
      this.$store.dispatch('setBreadcrumbs', breadcrumbs)
    },
    getPath(slug = '') {
      return `${this.lang ? `/${this.lang}` : ''}/service/${slug}`
    },
  },
  beforeMount() {
    this.updateHeadline()
  },
  beforeUpdate() {
    this.updateHeadline()
  },
  watch: {
    '$store.state.lang': function () {
      this.updateHeadline()
    },
  },
  mounted() {
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'other',
    })
  },
}
</script>

<style></style>
